// Mainly for dev purposes.
var baseUrl = 'https://aiudo.es';

export default {
  props: {
    currentStepIndex: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    selectedDays: {
      type: Array,
      required: true
    }
  },
  mounted: function () {
    // Update URL.
    history.pushState({}, this.currentStep.name, baseUrl + '/funnel/' + this.currentStep.slug);

    this.$nextTick(this.scrollToTop);

    /* window.gtag('event', 'page_view', {
      'send_to': 'UA-80431512-1',
      'page_title' : this.currentStep.name,
      'page_path': '/funnel/' + this.currentStep.slug,
      'page_location': 'https://aiudo.es/funnel/' + this.currentStep.slug
    }); */

    this.saveModelToStorage();
  },
  methods: {
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    saveModelToStorage: function () {
      this.$cookie.set('funnel_status', JSON.stringify(this.model), { expires: '6M' });
      this.$cookie.set('funnel_last_step', this.currentStepIndex, { expires: '6M' });
    }
  }
};
